import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BroadcastOutlinedIcon } from '@getgo/chameleon-icons/react';
import { Alert, Typography } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import ShowMoreContent from "../ShowMoreContent";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Linkify from 'react-linkify';
import classes from './CampaignMessageEvent.module.scss';
import TextTime from './TextTime';
const CampaignMessageEvent = ({ campaignDetails, fullWidth, compact, displayFullDate, isStartedByCampaign, }) => {
    const { t } = useTranslation();
    const text = useMemo(() => {
        const rawTranslation = isStartedByCampaign
            ? t('This conversation was started by the campaign {{by}}', {
                by: campaignDetails.name,
            })
            : t('This message was sent by the campaign {{by}}', {
                by: campaignDetails.name,
            });
        const splitTextAtCampaignName = rawTranslation.split(campaignDetails.name);
        return (_jsxs("span", { children: [splitTextAtCampaignName[0], _jsx(Typography, Object.assign({ tag: "span", variant: "body-small-semibold" }, { children: campaignDetails.name }), void 0), splitTextAtCampaignName[1]] }, void 0));
    }, [campaignDetails]);
    return (_jsx("div", Object.assign({ role: "listitem", className: classNames(classes.content, {
            [classes.fullWidth]: fullWidth,
            [classes.compact]: compact,
        }) }, { children: _jsxs(Alert, Object.assign({ icon: _jsx(BroadcastOutlinedIcon, {}, void 0), variant: "info" }, { children: [_jsx(TextTime, { text: text, time: campaignDetails.createdAt, displayFullDate: displayFullDate }, void 0), _jsx("div", Object.assign({ className: classes.body }, { children: _jsx(ShowMoreContent, { children: _jsx(Linkify, Object.assign({ componentDecorator: (decoratedHref, decoratedText, key) => (
                            /*
                             * This regex filters out the URL string as follows:
                             * match any word followed by a single:
                             * - full stop ( . )
                             * - forward slash ( / )
                             * - question mark ( ? )
                             * - pound sign ( # )
                             * - ampersand ( & )
                             * - colon ( : ) provided it not followed by two forward slashes ( // )
                             *
                             * The last clause ensures that `http` is not matched.
                             *
                             * Given decoratedText = "http://this.is.a.really.long.example.com:808/With/deeper/level/pages/deeper/level/pages/deeper/level/pages/deeper/level/pages/deeper/level/pages?t=43&b=345#468"
                             * Result will be: "http://this<wbr>.is<wbr>.a<wbr>.really<wbr>.long<wbr>.example<wbr>.com<wbr>:808<wbr>/With<wbr>/deeper<wbr>/level<wbr>/pages<wbr>/deeper<wbr>/level<wbr>/pages<wbr>/deeper<wbr>/level<wbr>/pages<wbr>/deeper<wbr>/level<wbr>/pages<wbr>/deeper<wbr>/level<wbr>/pages<wbr>?t=43<wbr>&b=345<wbr>#468"
                             *
                             * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/wbr for more information
                             * The HTML component <wbr> represents a word break opportunity.
                             */
                            _jsx("a", { href: decoratedHref, target: "_blank", rel: "noreferrer", dangerouslySetInnerHTML: {
                                    __html: decoratedText.replaceAll(/\w+(?=[./?#&]|(:(?!\/\/)))/gi, match => `${match}<wbr>`),
                                } }, key)) }, { children: _jsx("span", { children: campaignDetails.body }, void 0) }), void 0) }, void 0) }), void 0)] }), void 0) }), void 0));
};
export default CampaignMessageEvent;
//# sourceMappingURL=CampaignMessageEvent.js.map